import defineApi from '../define-api'
import http from '../application-api'

export const getDataCollectList = defineApi((config, params) => {
  config.params = params
  return http.load('/data_collect/list', config)
})
